import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { MatTable } from '@angular/material/table';
import { MatPaginator, PageEvent } from '@angular/material/paginator';
import { MatDialog } from '@angular/material/dialog';
import { DatePipe } from '@angular/common';
import { CategoryDialogComponent } from '../category-dialog/category-dialog.component';
import { HelperService } from 'src/app/shared/services/helper/helper.service';
import { FaqService } from 'src/app/shared/services/faq/faq.service';
import * as moment from 'moment';
export interface Category {
  id: number;
  category: string;
  createdAt: string;
}

@Component({
  selector: 'app-categories',
  templateUrl: './categories.component.html',
  styleUrls: ['./categories.component.scss'],
})
export class CategoriesComponent implements OnInit {
  @ViewChild(MatTable) table: MatTable<any> = Object.create(null);
  public searchText: any;
  public displayedColumns: string[] = [
    'index',
    'action',
    'id',
    'category',
    'createdAt',
  ];
  public i: number = 1;
  public data = {};
  public pageIndex: number = 0;
  public pageSize: number = 15;
  public length: number = 0;
  dataSource: any = [];
  pageSizeOptions: number[] = [5, 10, 15, 25, 100];
  public isProcessing = false;
  public searchedText: string = '';
  public showSearch: boolean = false;
  public toDate: any = '';
  public fromDate: any = '';
  public futureDate = new Date();

  // Tooltip
  public tooltip = {
    view_category: 'View Category',
    update_category: 'Update Category',
    delete_category: 'Delete Category',
  };

  // Order
  public orderOn = 'id';
  public orderBy = 'desc';

  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator =
    Object.create(null);
  @ViewChild('faqCategorySearch') faqCategorySearch: ElementRef | any;

  constructor(
    public dialog: MatDialog,
    public datePipe: DatePipe,
    private helperService: HelperService,
    private faqService: FaqService
  ) {}

  ngOnInit() {
    this.getCategories();
  }
  onDateRangeChange() {
    if (!!this.fromDate && !!this.toDate) {
      this.getCategories();
    }
  }

  sortData(event?: any) {
    const { active, direction } = event;
    this.orderOn = active;
    this.orderBy = direction;
    this.getCategories();
  }

  setDefaultPage(event?: PageEvent) {
    if (event) {
      this.pageIndex = event.pageIndex;
      this.pageSize = event.pageSize;
    } else {
      this.pageIndex = 0;
    }
  }

  async getCategories(event?: PageEvent) {
    try {
      if (event) {
        this.pageIndex = event.pageIndex;
        this.pageSize = event.pageSize;
      }
      this.isProcessing = true;
      let faqCategoryURL = '';
      if (this.searchedText) {
        faqCategoryURL += `&search=${this.searchedText}`;
        this.setDefaultPage(event);
      }

      if (this.orderOn && this.orderBy) {
        faqCategoryURL += `&orderOn=${
          this.orderOn
        }&orderBy=${this.orderBy.toUpperCase()}`;
        this.setDefaultPage(event);
      }

      if (this.fromDate && this.toDate) {
        faqCategoryURL += `&fromDate=${moment(this.fromDate).format(
          'YYYY-MM-DD'
        )}&toDate=${moment(this.toDate).format('YYYY-MM-DD')}`;
        this.setDefaultPage(event);
      }
      faqCategoryURL += `&page=${this.pageIndex + 1}&perPage=${this.pageSize}`;
      const res = await this.faqService.faqGetCategories(faqCategoryURL);
      if (res) {
        this.data = res.data.faqCategories;
        this.dataSource = res.data.faqCategories;
        this.length = res.data.count;
      }
    } catch (err: any) {
      this.helperService.showAlert(
        err.error || 'Something went wrong',
        'error'
      );
    } finally {
      this.isProcessing = false;
    }
  }

  showHideSearch() {
    this.showSearch = !this.showSearch;
    setTimeout(() => {
      if (this.faqCategorySearch && this.faqCategorySearch.nativeElement) {
        this.faqCategorySearch.nativeElement.focus();
      }
    });
  }

  clearSearch() {
    this.searchedText = '';
    this.showHideSearch();
    this.getCategories();
  }

  ngAfterViewInit(): void {
    this.dataSource.paginator = this.paginator;
  }

  applyFilter(filterValue: string): void {
    this.dataSource.filter = filterValue.trim().toLowerCase();
  }
  isFilterApplied() {
    return !this.toDate;
  }
  clearFilter() {
    this.fromDate = '';
    this.toDate = '';
    this.getCategories();
  }
  openDialog(action: string, obj: any): void {
    obj.action = action;
    const dialogRef = this.dialog.open(CategoryDialogComponent, {
      minWidth: obj.action && obj.action === 'Delete' ? '500px' : '700px',
      data: obj,
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (result && result.event) {
        if (result.event === 'Add') {
          if (result.success) {
            this.addRowData(result.data);
          }
        } else if (result.event === 'Update') {
          if (result.success) {
            this.updateRowData(result.data);
          }
        } else if (result.event === 'Delete') {
          if (result.success) {
            this.deleteRowData();
          }
        }
      }
    });
  }

  addRowData(row_obj: Category): void {
    const categoryObj = {
      id: row_obj.id,
      category: row_obj.category,
      createdAt: row_obj.createdAt,
    };

    if (this.dataSource.length === this.pageSize) {
      this.dataSource.pop();
    }
    this.dataSource = [categoryObj, ...this.dataSource];
    this.length += 1;
    this.table.renderRows();
  }

  updateRowData(row_obj: Category): boolean | void {
    this.dataSource = this.dataSource.filter((value: any) => {
      if (value.id === row_obj.id) {
        value.category = row_obj.category;
      }
      return true;
    });
    this.table.renderRows();
  }

  deleteRowData() {
    this.getCategories();
  }
}
